var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.116 18.404L20 14.52L23.8864 18.4056L26.1464 16.1456L20 10L13.856 16.144L16.116 18.404ZM10 20L12.26 17.74L14.52 20L12.26 22.26L10 20ZM16.116 21.596L20 25.48L23.8856 21.5944L26.1472 23.8528L26.1464 23.8544L20 30L13.856 23.856L13.8528 23.8528L16.116 21.596ZM25.48 20.0008L27.74 17.7408L30 20.0008L27.74 22.2608L25.48 20.0008Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.292 19.9992H22.2928L20 17.7056L18.3048 19.4L18.1104 19.5944L17.7088 19.996L17.7056 19.9992L17.7088 20.0024L20 22.2944L22.2936 20.0008L22.2944 19.9992H22.292Z",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.69c4f272e2dd2163a35fcb3279f8435e.svg";
export { ForwardRef as ReactComponent };